export enum GameOverReason {
  Win = 'win',
  LostNoQuestionsLeft = 'lost-no-questions-left',
  LostNoValuation = 'lost-no-valuation',
  LostNoSatisfaction = 'lost-no-satisfaction',
}
